import React from 'react';

const DeleteModal = ({open, setDeleting, lineItem, handleDelete}) => {

    if(!open) return null;

    return (
        <React.Fragment>

            {lineItem._id == 'new-0' &&
                <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                <div className="bg-white mx-auto rounded shadow p-5 text-center">
                    <div>An invoice must contain it's initial line item - adjust the line item instead of removing it.</div>
                    <div><strong> This line item can't be deleted.</strong></div>
                    <div className="pt-3">
                        <button onClick={() => {  
                            setDeleting(false)        
                        }} type="button" className="btn btn-secondary mr-2">
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
            }

            {lineItem._id != 'new-0' &&
                <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
                    <div className="bg-white mx-auto rounded shadow p-5 text-center">
                        <div>Please confirm. This will remove the line item from the invoice.</div>
                        <div><strong> This can't be undone.</strong></div>
                        <div className="pt-3">
                            <button onClick={() => {  
                                setDeleting(false)        
                            }} type="button" className="btn btn-secondary mr-2">
                                Cancel
                            </button>
                            <button onClick={() => {
                                handleDelete(lineItem)
                            }} type="button" className="btn btn-outline-danger">
                                Yes, delete line item. 
                            </button>
                        </div>
                    </div>
                </div>
            }   
        </React.Fragment>
    )

}

export default DeleteModal